(function () {

    const drawer = document.getElementById("HomepageFilterDrawer");
    const overlay = document.getElementById("HomepageFilterOverlay");
    const title = document.getElementById("HomepageFilterTitle");
    const content = document.getElementById("HomepageFilterContent");
    const applyButton = document.getElementById("HomepageApplyFilters");
    const closeButton = document.getElementById("HomepageFilterClose");

    const SHOP_ALL_COLLECTION = "shop-all";

    if (!drawer || !overlay || !title || !content) {
        console.warn("Homepage Filter: Required elements not found.");
        return;
    }

    function closeDrawer() {
        drawer.classList.remove("active");
        overlay.classList.remove("active");
    }

    /* -----------------------------------------
       DUAL SLIDER Z-INDEX & SYNC FIX
    ----------------------------------------- */
    /* -----------------------------------------
   PRICE SLIDER REAL-TIME SYNC & TRACK FIX
----------------------------------------- */
function bindPriceSliderEvents(container) {
    const minInput = container.querySelector('input[name="filter.v.price.gte"]');
    const maxInput = container.querySelector('input[name="filter.v.price.lte"]');
    const rangeInputs = Array.from(container.querySelectorAll('input[type="range"]'));

    if (!rangeInputs.length) return;

    // Identify Min (From) and Max (To) inputs explicitly
    const minRange = rangeInputs.find(r => r.name?.includes('gte') || r.classList.contains('range-min')) || rangeInputs[0];
    const maxRange = rangeInputs.find(r => r.name?.includes('lte') || r.classList.contains('range-max')) || rangeInputs[1] || rangeInputs[0];

    // Determine absolute max price limit
    const maxPriceLimit = parseFloat(
        maxRange.getAttribute('max') || minRange.getAttribute('max') || maxRange.max || 100
    );

    // Explicitly set slider range boundaries
    minRange.setAttribute('min', '0');
    minRange.setAttribute('max', maxPriceLimit);
    maxRange.setAttribute('min', '0');
    maxRange.setAttribute('max', maxPriceLimit);

    // Set initial values from input fields or defaults
    const initialMin = minInput && minInput.value !== "" ? parseFloat(minInput.value) : 0;
    const initialMax = maxInput && maxInput.value !== "" ? parseFloat(maxInput.value) : maxPriceLimit;

    minRange.value = initialMin;
    maxRange.value = initialMax;

    // Update track bar visual background
    function updateSliderTrack() {
        const minVal = parseFloat(minRange.value || 0);
        const maxVal = parseFloat(maxRange.value || maxPriceLimit);

        const lowPercent = (minVal / maxPriceLimit) * 100;
        const highPercent = (maxVal / maxPriceLimit) * 100;

        // Apply visual CSS variables
        container.style.setProperty('--low', `${lowPercent}%`);
        container.style.setProperty('--high', `${highPercent}%`);
        minRange.style.setProperty('--range-progress', `${lowPercent}%`);
        maxRange.style.setProperty('--range-progress', `${highPercent}%`);

        // Prevent pointer overlap: Keep active thumb on top
        if (minVal > (maxPriceLimit / 2)) {
            minRange.style.zIndex = "5";
            maxRange.style.zIndex = "4";
        } else {
            minRange.style.zIndex = "4";
            maxRange.style.zIndex = "5";
        }
    }

    /* -----------------------------------------
       1. MIN SLIDER (FROM)
    ----------------------------------------- */
    if (minRange && minInput) {
        ['input', 'change'].forEach(eventType => {
            minRange.addEventListener(eventType, (e) => {
                e.stopPropagation(); // Stop Shopify Dawn theme scripts from hijacking event
                let val = parseFloat(minRange.value);
                let maxVal = parseFloat(maxRange.value);

                if (val > maxVal) {
                    minRange.value = maxVal;
                }
                minInput.value = minRange.value;
                updateSliderTrack();
            });
        });

        minInput.addEventListener('input', () => {
            minRange.value = minInput.value !== "" ? minInput.value : 0;
            updateSliderTrack();
        });
    }

    /* -----------------------------------------
       2. MAX SLIDER (TO)
    ----------------------------------------- */
    if (maxRange && maxInput) {
        ['input', 'change'].forEach(eventType => {
            maxRange.addEventListener(eventType, (e) => {
                e.stopPropagation(); // Stop Shopify Dawn theme scripts from hijacking event
                let val = parseFloat(maxRange.value);
                let minVal = parseFloat(minRange.value);

                if (val < minVal) {
                    maxRange.value = minVal;
                }
                maxInput.value = maxRange.value;
                updateSliderTrack();
            });
        });

        maxInput.addEventListener('input', () => {
            maxRange.value = maxInput.value !== "" ? maxInput.value : maxPriceLimit;
            updateSliderTrack();
        });
    }

    // Initial positioning
    updateSliderTrack();
}

    /* -----------------------------------------
       LOAD SHOP ALL FILTERS
    ----------------------------------------- */
    async function loadShopAllFilters() {
        content.innerHTML = "<p>Loading filters...</p>";

        try {
            const url = `/collections/${SHOP_ALL_COLLECTION}?section_id=main-collection-product-grid`;
            const response = await fetch(url, { credentials: "same-origin" });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const filters = doc.querySelector("#FacetFiltersFormMobile");

            if (!filters) {
                content.innerHTML = "<p>Filters not found.</p>";
                return;
            }

            content.innerHTML = "";
            const wrapper = document.createElement("div");
            wrapper.className = "homepage-filter-form-wrapper";

            // Clone form markup
            const clonedFilters = filters.cloneNode(true);

            // UNWRAP <price-range> custom element so theme JS stops overriding slider movements
            clonedFilters.querySelectorAll('price-range').forEach(pr => {
                const div = document.createElement('div');
                div.className = pr.className;
                div.innerHTML = pr.innerHTML;
                pr.parentNode.replaceChild(div, pr);
            });

            wrapper.appendChild(clonedFilters);
            content.appendChild(wrapper);

            // Clean up trailing arrows
            content.querySelectorAll('.mobile-facets__summary').forEach((summary) => {
                summary.innerHTML = summary.innerHTML.replace(/→|&rarr;/g, '');
            });

            // Bind dual-slider handlers & z-index fixes
            bindPriceSliderEvents(content);

        } catch (error) {
            console.error("Homepage filter error:", error);
            content.innerHTML = "<p>Unable to load filters.</p>";
        }
    }

    /* -----------------------------------------
       OPEN DRAWER
    ----------------------------------------- */
    function openHomepageFilter() {
        title.textContent = "Filter and Sort";
        drawer.classList.add("active");
        overlay.classList.add("active");
        loadShopAllFilters();
    }

    /* -----------------------------------------
       APPLY FILTERS
    ----------------------------------------- */
    function applyHomepageFilters(form) {
        if (!form) return;

        const params = new URLSearchParams(new FormData(form));
        params.delete("section_id");

        for (const [key, value] of Array.from(params.entries())) {
            if (!value) params.delete(key);
        }

        const queryString = params.toString();
        const url = `/collections/${SHOP_ALL_COLLECTION}` + (queryString ? `?${queryString}` : "");

        window.location.href = url;
    }

    /* -----------------------------------------
       EVENT LISTENERS
    ----------------------------------------- */
    applyButton?.addEventListener("click", function (event) {
        event.preventDefault();
        const form = content.querySelector("form");
        applyHomepageFilters(form);
    });

    document.querySelectorAll(".homepage-filter-btn").forEach(function (button) {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            openHomepageFilter();
        });
    });

    document.addEventListener("submit", function (event) {
        const form = event.target.closest("#HomepageFilterContent form");
        if (!form) return;
        event.preventDefault();
        applyHomepageFilters(form);
    }, true);

    closeButton?.addEventListener("click", closeDrawer);
    overlay?.addEventListener("click", closeDrawer);

    window.openHomepageFilter = openHomepageFilter;

})();

/* -----------------------------------------
   CLEAR BUTTON FUNCTIONALITY
----------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
    const clearButton = document.getElementById('HomepageFilterClear');
    if (!clearButton) return;

    clearButton.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.href = `/collections/shop-all`;
    });
});